import {
    Drawer,
    Input,
    Col,
    Select,
    Form,
    Button,
    Row,
    Spin
} from 'antd';
import { LoadingOutlined } from "@ant-design/icons";
import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useAxiosPrivate from '@/context/UseAxiosPrivate';
import ActivateVehicle from './ActivateVehicle';
import ReverseActivation from './ReverseActivation';
import { errorNotification } from '@/utils/Notification';
import { Assets } from '../assets/AssetColumns';
import SpinnerForm from '../spinnner/SpinnerForm';

const { Option } = Select;
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

interface ProductsDrawerProps {
    showMainActivateDrawer: boolean;
    setShowMainActivateDrawer: React.Dispatch<React.SetStateAction<boolean>>;
    getAssets: any;
    Assets: Assets;
    setAssetData: React.Dispatch<React.SetStateAction<Assets | undefined>>;
}

const AddBeaconDrawer: React.FC<ProductsDrawerProps> = ({ showMainActivateDrawer, setShowMainActivateDrawer, getAssets, Assets, setAssetData }) => {
    const [activeTab, setActiveTab] = useState('tab1');
    const [beaconsToDisplay, setBeaconsToDisplay] = useState<any[]>([]);
    const [loadingTechnicianBeacons, setLoadingTechnicianBeacons] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();
    const axiosPrivate = useAxiosPrivate();

    useEffect(() => {
        if (Assets.status === 0) {
            setActiveTab('tab1');
        } else if (Assets.status === 1) {
            setActiveTab('tab2');
        }
    }, [Assets.status]);

    const getTechniciansBeacons = (technician_store_id: any) => {
        let isMounted = true;
        const controller = new AbortController();

        setLoadingTechnicianBeacons(true);

        axiosPrivate.get(`/api/v1/beacons/technicianBeacons?beaconStoreId=${technician_store_id}`, {
            signal: controller.signal
        }).then((response: any) => response.data.data)
            .then((data: any) => {
                if (isMounted) {
                    setBeaconsToDisplay(data);
                }
            }).catch((err: any) => {
                const errors = err?.response?.data?.errors;
                if (errors && errors?.[0]?.message === "token as expired") {
                    errorNotification("There was an issue", `${errors?.[0]?.message}`, 'topRight');
                    navigate('/', { state: { from: location }, replace: true });
                } else if (errors && Array.isArray(errors) && errors.length > 0) {
                    errors.forEach((error: any) => {
                        const errorMessage = error.message || "An unknown error occurred";
                        errorNotification("There was an issue", `${errorMessage}`, 'topRight');
                    });
                } else {
                    errorNotification("There was an issue", "No server response", 'topRight');
                    navigate('/', { state: { from: location }, replace: true });
                }
            }).finally(() => {
                if (isMounted) {
                    setLoadingTechnicianBeacons(false);
                }
            });

        return () => {
            isMounted = false;
            controller.abort();
        };
    };

    useEffect(() => {
        if (Assets.technician_store_id) {
            getTechniciansBeacons(Assets.technician_store_id);
        }
    }, [Assets.technician_store_id]);

    const renderContent = () => {
        switch (activeTab) {
            case 'tab1':
                return <ActivateVehicle Assets={Assets} setShowMainActivateDrawer={setShowMainActivateDrawer} getAssets={getAssets} beaconsToDisplay={beaconsToDisplay} />;
            case 'tab2':
                return <ReverseActivation Assets={Assets} setShowMainActivateDrawer={setShowMainActivateDrawer} getAssets={getAssets} />;
            default:
                return <p className="text-lg">This is the content for Tab 1: Overview of beacons.</p>;
        }
    };

    return (
        <Drawer
            title={`${Assets.registration}`}
            width={720}
            onClose={() => { setAssetData(undefined); setShowMainActivateDrawer(false); }}
            open={showMainActivateDrawer}
            bodyStyle={{ paddingBottom: 80 }}
            style={{
                backgroundColor: 'white',
                transition: 'transform 0.3s ease, opacity 0.3s ease'
            }}
            maskStyle={{
                transition: 'opacity 0.3s ease'
            }}
            footer={
                <div style={{ textAlign: 'right' }}>
                    <Button onClick={() => { setAssetData(undefined); setShowMainActivateDrawer(false); }} style={{ marginRight: 8 }}>
                        Cancel
                    </Button>
                </div>
            }
        >
            {loadingTechnicianBeacons && activeTab ==="tab1" ? (
                <div>
                    <SpinnerForm />
                </div>
            ) : (
                <>
                    <div className="flex space-x-4 mb-6 border-b">
                        {Assets.status === 0 && (
                            <button
                                onClick={() => setActiveTab('tab1')}
                                className={`pb-2 px-4 text-base font-semibold ${activeTab === 'tab1' ? 'border-b-2 border-blue-500 text-blue-500' : 'text-gray-500'}`}
                            >
                                Activate Vehicle
                            </button>
                        )}
                        {Assets.status === 1 && (
                            <button
                                onClick={() => setActiveTab('tab2')}
                                className={`pb-2 px-4 text-base font-semibold ${activeTab === 'tab2' ? 'border-b-2 border-blue-500 text-blue-500' : 'text-gray-500'}`}
                            >
                                Reverse Activation
                            </button>
                        )}
                    </div>
                    <div className="px-4 mt-11">
                        <div className="space-y-4">
                            <div className="flex justify-between">
                                <h1 className="font-semibold">
                                    <span className="text-base font-bold">Client Name: </span> {Assets.client_name}
                                </h1>
                                <h1 className="font-semibold">
                                    <span className="text-base font-bold">Loan Id: </span> {Assets.loan_id}
                                </h1>
                            </div>
                            <div>
                                <h1 className="font-semibold">
                                    <span className="text-base font-bold">Business Source: </span> {Assets.customer_name}
                                </h1>
                            </div>
                            <div>
                                <h1 className=" font-semibold">
                                    <span className="text-base font-bold">Technician: </span> {Assets.technician_name} beacons
                                </h1>
                            </div>
                        </div>
                        {renderContent()}
                    </div>
                </>
            )}
        </Drawer>
    );
};

export default AddBeaconDrawer;
